import { i18n } from "translate/i18n";

export const linkCopied = i18n.t("messages.linkCopied");
export const copyLink = i18n.t("messages.copyLink");
export const throughLink = i18n.t("messages.throughLink");
export const inviteViaEmail = i18n.t("messages.inviteViaEmail");
export const shareLink = i18n.t("messages.shareLink");
export const hereIsTheLink = i18n.t("messages.hereIsTheLink");
